'use client';

import { MessageCircle } from 'lucide-react';
import { useChatUI } from '@/stores/chat-ui';

interface Props {
  className?: string;
  label?: string;
  withIcon?: boolean;
}

/**
 * Tiny client button that opens the "Fråga Erik" chat — used from server
 * components (Footer) and anywhere a regular Link would normally go.
 */
export function AskErikLink({ className = '', label = 'Fråga Erik', withIcon = false }: Props) {
  const open = useChatUI((s) => s.open);
  return (
    <button
      type="button"
      onClick={open}
      className={`text-left inline-flex items-center gap-1.5 ${className}`}
    >
      {withIcon && <MessageCircle className="h-3.5 w-3.5" />}
      {label}
    </button>
  );
}
